import { Page } from '../components/ui';
import {
  StatementTableSection,
  StatementTopChart,
  StatementBottomChart,
  useFinancialStatementsPage,
} from '../features/financial-statements';
import '../css/financial-statements.css';

export const FinancialStatements = () => {
  const fs = useFinancialStatementsPage();

  const topTitle =
    fs.statementType === 'balance' ? 'ASSETS OVERVIEW' : fs.config.lineChart.title;
  const bottomTitle =
    fs.statementType === 'balance' ? 'EQUITY & LIABILITY OVERVIEW' : fs.config.barChart.title;

  return (
    <Page className="fs-page">
      <div className={`fs-layout ${fs.isExpanded ? 'fs-layout--expanded' : ''}`}>
        <StatementTableSection
          title={fs.config.title}
          currencyCode={fs.currencyCode}
          statementType={fs.statementType}
          selectedPeriod={fs.selectedPeriod}
          availablePeriods={fs.availablePeriods}
          valueMode={fs.valueMode}
          isExpanded={fs.isExpanded}
          onStatementTypeChange={fs.selectStatementType}
          onPeriodChange={fs.setSelectedPeriod}
          onValueModeChange={fs.setValueMode}
          onToggleExpand={() => fs.setIsExpanded(!fs.isExpanded)}
          onPeriodsChange={fs.setAvailablePeriods}
          onFilteredDataChange={fs.handleFilteredDataChange}
        />

        {!fs.isExpanded && (
          <>
            <StatementTopChart
              statementType={fs.statementType}
              currencyCode={fs.currencyCode}
              topTitle={topTitle}
              lineChartData={fs.lineChartData}
              lineChartLoading={fs.lineChartLoading}
              lineYAxisLabel={fs.config.lineChart.yAxisLabel}
              assetsWaterfallData={fs.assetsWaterfallData}
              balanceWaterfallLoading={fs.balanceWaterfallLoading}
              incomeNOIChartData={fs.incomeNOIChartData}
              filteredStatementData={fs.filteredStatementData}
            />

            <StatementBottomChart
              statementType={fs.statementType}
              currencyCode={fs.currencyCode}
              bottomTitle={bottomTitle}
              bottomLineChartData={fs.bottomLineChartData}
              bottomLineChartLoading={fs.bottomLineChartLoading}
              liabilitiesWaterfallData={fs.liabilitiesWaterfallData}
              balanceWaterfallLoading={fs.balanceWaterfallLoading}
              incomeOpExChartData={fs.incomeOpExChartData}
              filteredStatementData={fs.filteredStatementData}
            />
          </>
        )}
      </div>
    </Page>
  );
};
